import { useEffect, useState } from "react";

// Matches the .route-fallback animation delay in index.css.
const REVEAL_DELAY_MS = 150;

/**
 * Shown while a lazy route's chunk loads. Invisible for the first 150ms (.route-fallback
 * in index.css), so quick loads never flash; reduced motion shows it at once. The status
 * text arrives with the visual, so screen readers are not told about loads nobody sees.
 */
export function RouteFallback() {
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const handle = window.setTimeout(() => setRevealed(true), REVEAL_DELAY_MS);
    return () => window.clearTimeout(handle);
  }, []);

  return (
    <div
      role="status"
      className="route-fallback flex min-h-screen items-center justify-center bg-canvas px-6"
    >
      <div className="flex flex-col items-center gap-3">
        <span
          aria-hidden="true"
          className="h-6 w-6 animate-spin rounded-full border-2 border-line border-t-primary"
        />
        {/* Holds its line while empty so the spinner does not move when the text arrives. */}
        <p className="min-h-[1lh] text-eyebrow uppercase text-ink-2">{revealed ? "Loading" : null}</p>
      </div>
    </div>
  );
}
